import SectionHeading from '@/pages/home/components/SectionHeading';
import { versionCompare } from '@/mocks/cinemaData';

export default function DesktopSection() {
  return (
    <section id="desktop" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="电脑版 / 网页版"
          title="秋霞影院电脑版、网页版分别适合什么场景"
          desc="电脑版与网页版经常被混用，但它们的侧重点并不相同。下表从打开方式、屏幕适配到典型场景做了一次横向对照，方便你按使用习惯选择。"
        />

        <div className="mt-10 overflow-x-auto rounded-lg border border-background-200">
          <table className="w-full min-w-[560px] border-collapse text-left text-sm">
            <caption className="sr-only">手机版、电脑版与网页版访问方式对比</caption>
            <thead>
              <tr className="bg-secondary-100 text-secondary-900">
                <th scope="col" className="whitespace-nowrap px-4 py-3 font-medium">对比项</th>
                <th scope="col" className="whitespace-nowrap px-4 py-3 font-medium">手机版</th>
                <th scope="col" className="whitespace-nowrap px-4 py-3 font-medium">电脑版</th>
                <th scope="col" className="whitespace-nowrap px-4 py-3 font-medium">网页版</th>
              </tr>
            </thead>
            <tbody>
              {versionCompare.map((row, index) => (
                <tr
                  key={row.item}
                  className={index % 2 === 0 ? 'bg-background-50' : 'bg-background-100'}
                >
                  <th scope="row" className="whitespace-nowrap px-4 py-3 font-medium text-foreground-900">
                    {row.item}
                  </th>
                  <td className="px-4 py-3 text-foreground-600">{row.mobile}</td>
                  <td className="px-4 py-3 text-foreground-600">{row.desktop}</td>
                  <td className="px-4 py-3 text-foreground-600">{row.web}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          <article className="rounded-lg border border-background-200 bg-background-100 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className="ri-computer-line text-lg" aria-hidden="true" />
            </span>
            <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">电脑版的主要特点</h3>
            <ul className="mt-3 space-y-2 text-sm leading-relaxed text-foreground-600">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500" aria-hidden="true" />
                以多列网格展示内容，一屏可见条目更多，浏览效率更高。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500" aria-hidden="true" />
                更依赖鼠标悬停与快捷键操作，适合长时间、沉浸式观看。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500" aria-hidden="true" />
                大屏下播放器控件更完整，画质与音量调节更细致。
              </li>
            </ul>
          </article>

          <article className="rounded-lg border border-background-200 bg-background-100 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-global-line text-lg" aria-hidden="true" />
            </span>
            <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">网页版的主要特点</h3>
            <ul className="mt-3 space-y-2 text-sm leading-relaxed text-foreground-600">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true" />
                完全免安装，换设备、临时借用他人电脑时最省事。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true" />
                布局随窗口宽度自适应，宽屏像电脑版，窄屏像手机版。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true" />
                更新由服务端完成，用户无需手动升级版本。
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
}